import { render, staticRenderFns } from "./price-breakdown.vue?vue&type=template&id=52c37fba"
import script from "./price-breakdown.vue?vue&type=script&lang=js"
export * from "./price-breakdown.vue?vue&type=script&lang=js"
import style0 from "./price-breakdown.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports